/* eslint eqeqeq: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Table, Button, Modal } from 'reactstrap';
import classnames from 'classnames';
import '../../../../../Assets/EnsembleStyles/Filter.css';
// import AddZoneForm1 from '../_ModalsForms/Zones/AddZoneForm_1';
import AddZoneForms from '../_ModalsForms/Zones/AddZoneForms';
import EditZoneForm from '../_ModalsForms/Zones/EditZoneForm'
import ErrorGif from '../../../../../Assets/images/Error.gif';
import { GetZonesList, DeleteZone } from '../../../../../action/ZonesAction';
import DeleteConfirmation from '../_ModalsForms/DeleteConfirmation';
import { closeModalPopUp } from '../../../../../action/modalStateAction';
import SearchInput, { createFilter } from 'react-search-input';
import SelectAllCheckboxes from '../../../../../Resources/SelectAllCheckboxes';
import LoadingIndicator from '../../../Common/LoadingIndicator';

const KEYS_TO_FILTERS = ['zoneName','members.objectName' , 'buildingName', 'tenantNames'];

class Zones extends Component {
    componentWillMount() {
        this.props.GetZonesList().then(() => this.setState({isloading: false}));
        this.setState({
            modal: false
        });
    }

    constructor(props) {
        super(props);
        this.state = {
            isloading: true,
            modal: false,
            Deletemodal: false,
            Editmodal: false,
            error_msg: false,
            selected_Check_Boxes: [],
            searchTerm: '',
            zoneID: 0,
            ZoneDetails: [],
            sort: {
                column: 'zoneName',
                direction: [
                    {name:'zoneName', direction:'asc', onclick:true},
                    {name:'buildingName', direction:'desc', onclick:false},
                    {name:'members', direction:'desc', onclick:false},
                    {name:'tenantNames', direction:'desc', onclick:false}
                ],
            },
            IsDefaultSort: true,
            IsChangesSaved: false,
        };
        this.toggle = this.toggle.bind(this);
        this.Deletetoggle = this.Deletetoggle.bind(this);
        this.Edittoggle = this.Edittoggle.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        this.LoadZone = this.LoadZone.bind(this);
        this.deleteZones = this.deleteZones.bind(this);
    }

    Edittoggle() {
        this.props.closeModalPopUp("open");
        this.setState({
            Editmodal: true
        });
    }

    LoadZone(zoneId) {
        let zonedts = this.props.getResponse.ZonesList;
        if (zonedts !== undefined && zonedts !== null) {
            zonedts = zonedts.filter(function (item) {
                return item.zoneId === zoneId
            });
        }
        this.setState({
            zoneID: zoneId,
            ZoneDetails: zonedts
        });
        this.Edittoggle();
    }

    deleteZones() {
        this.setState({ error_msg: false });
        var IsAnyChecked = false;
        var checkboxes = document.getElementsByClassName('ZoneRows');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                IsAnyChecked = true;
            }
        }
        if (IsAnyChecked) this.Deletetoggle();
        else this.setState({ error_msg: true });
    }
    /* Delete Confirmation*/

    Delete = (someArg) => {
        if (someArg == "yes") {
            var Data = [];
            var checkboxes = document.getElementsByClassName('ZoneRows');
            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked === true) {
                    var Zone_id_to_be_deleted = {
                        "zoneId": checkboxes[i].id
                    }
                    Data.push(Zone_id_to_be_deleted);
                }

            }
            if (Data.length > 0) {
                this.setState({ error_msg: false });
                console.log(Data);
                this.props.DeleteZone(Data);
                this.Deletetoggle();
            }
            else {
                this.setState({ error_msg: true });
                this.Deletetoggle();
            }

        }
        else {
            this.Deletetoggle();
        }
    }

    /* Modal Pop ups*/
    toggle() {
        this.props.closeModalPopUp("open");
        this.setState({
            modal: true
        });
    }

    Deletetoggle() {
        this.setState({
            Deletemodal: !this.state.Deletemodal
        });
    }

    /* Sorting  System */

    onSort = (column) => (e) => {
        this.setState({IsDefaultSort:false});
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.props.getResponse.ZonesList;
        var notequals = 0;

       if(data_from_state != null){
        const sortedData = this.props.getResponse.ZonesList.sort((a, b) => {
            const nameA = (column == 'members') ? a[column].map(xl => (xl.objectName)).join(', ').toLowerCase() : (column == 'tenantNames') ? a[column].join(', ').toLowerCase() : a[column].toLowerCase();
            const nameB = (column == 'members') ? b[column].map(xl => (xl.objectName)).join(', ').toLowerCase() : (column == 'tenantNames') ? b[column].join(', ').toLowerCase() : b[column].toLowerCase();
            if (nameA < nameB) {
                notequals = 1;
                return -1;
            }
            if (nameA > nameB) {
                notequals = 1;
                return 1;
            }
            if (nameA == nameB) {
                return 0;
            }
            return 0;
        });

        if(selected[0].direction =='asc' && notequals == 1){
        sortedData.reverse();
     }

     SortData.map(x => (x.name !== column) ? x.onclick = false : x.onclick = true);
     SortData.map(x => (x.name !== column) ? x.direction = SortData.filter(m => (m.name === x.name))[0].direction : x.direction = direction);

     this.props.getResponse.ZonesList = sortedData;
        this.setState({
            sort: {
                column,
                direction:SortData,
            }
        });
       }
    };

    setArrow = (column) => {
        let className = 'workorder-sort-direction';
        let sortColumn = this.state.sort.direction.filter(x => (x.name === column))[0];
        className += (sortColumn.onclick === true) ? (sortColumn.direction === 'asc') ? ' asccolor' : ' desccolor' : ' desc';
        return className;
    };

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            var modalClose = nextProps.ModalOpenCloseResponse.ModalOpenClose.modal_open;
            if (modalClose == "close") {
                this.setState({ modal: false, Editmodal: false, IsChangesSaved: true });
            }
        }
    }


    render(getResponse,getLabels, UserCanEdit) {

        let Zones, Error_Message, ZonedList, FilteredData, lUserCanEdit = true;
        let label = this.props.getLabels;

        lUserCanEdit = this.props.UserCanEdit;
        lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit ? true : false;

        if (this.props.getResponse != undefined && this.props.getResponse.ZonesList != null && !this.state.isloading) {
            if (this.props.getResponse.ZonesList.length) {               
                if(this.state.IsDefaultSort){
                    this.props.getResponse.ZonesList.sort((a,b)=>{
                        let nameA = a['zoneName'].toLowerCase();
                        let nameB = b['zoneName'].toLowerCase();
                        if(nameA < nameB){
                            return -1;
                        }
                        if(nameA > nameB){
                            return 1;
                        }
                        if(nameA == nameB){
                            return 0;
                        }
                        return 0;
                    });
                }
                if(this.state.IsChangesSaved){
                    this.props.getResponse.ZonesList.sort((a,b) => {
                        let nameA = (this.state.sort.column == 'members') ? a[this.state.sort.column].map(xl => (xl.objectName)).join(', ').toLowerCase() : (this.state.sort.column == 'tenantNames') ? a[this.state.sort.column].join(', ').toLowerCase() : a[this.state.sort.column].toLowerCase();
                        let nameB = (this.state.sort.column == 'members') ? b[this.state.sort.column].map(xl => (xl.objectName)).join(', ').toLowerCase() : (this.state.sort.column == 'tenantNames') ? b[this.state.sort.column].join(', ').toLowerCase() : b[this.state.sort.column].toLowerCase();
                        if(nameA < nameB){
                            return -1;
                        }
                        if(nameA > nameB){
                            return 1;
                        }
                        if(nameA == nameB){
                            return 0;
                        }
                        return 0;
                    });
                    if(this.state.sort.direction.filter(x => x.name === this.state.sort.column)[0].direction === "desc"){
                        this.props.getResponse.ZonesList.reverse();
                    }
                    this.setState({IsChangesSaved:false})
                }
                ZonedList = this.props.getResponse.ZonesList;
                FilteredData = ZonedList.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
                
                Zones = (FilteredData.length > 0) ? FilteredData.map(el => (
                    <tr key={el.zoneId}>
                        <td width="5%"><input type="checkbox" id={el.zoneId} className="ZoneRows" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("ZoneRows", "main_Check_box"); }} /></td>
                        <td width="20%">
                        {
                            lUserCanEdit ? <p onClick={() => { this.LoadZone(el.zoneId) }} style={{ color: '#6890C6' }} className="link_cursor">{el.zoneName}</p> : <p className="link_cursor">{el.zoneName}</p>
                        }
                        </td>
                        <td width="20%">{el.buildingName}</td>
                        <td width="30%">{el.members.map(xl => (xl.objectName)).join(', ')}</td>
                        <td width="25%">{el.tenantNames.join(', ')}</td>
                    </tr>
                )) : <tr> <td colSpan="5">{label['NoRecords.Text']}</td> </tr>;
            }
            else{
                Zones =  <tr> <td colSpan="5">{label['NoRecords.Text']}</td> </tr>
            }
        }
        else {
            Zones = <tr><td colSpan="5" style={{textAlign: 'center'}}><LoadingIndicator/></td></tr> 
        }

        // Error Message
        (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" /> {label['CheckEmptyZones.Text'] !== undefined ? label['CheckEmptyZones.Text'] : "Error: Select one or more Zone to perform this action."} </p> : Error_Message = " ";


        return (
            <div className="tenant_content_border">
                <div className="main_container">
                    {Error_Message}

                    <div className="buttons_container">
                        <Button type="button" hidden={!lUserCanEdit} className="btn btn-black" onClick={this.deleteZones}>{label['TenantZones.Delete.Text'] !== undefined ? label['TenantZones.Delete.Text'] : "Delete"} </Button>
                        <Button type="button" hidden={!lUserCanEdit} className="btn btn-success" onClick={this.toggle} >{label['TenantZones.AddZone.Text'] !== undefined ? label['TenantZones.AddZone.Text'] : "Add New Zone"}  </Button>
                        <SearchInput className="search-input" onChange={this.searchUpdated} />
                    </div>

                    <div className="table_container">
                        <Table striped responsive className="Custom_table table_border">
                            <tbody className="cell_container tenant_cell">
                                <tr>
                                    <th><input type="checkbox" className="main_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("ZoneRows", "main_Check_box"); }} /></th>
                                    <th onClick={this.onSort('zoneName')} className="link_cursor">{label['TenantZones.Zone.Text'] !== undefined ? label['TenantZones.Zone.Text'] : "Zone"} <span className={this.setArrow('zoneName')}></span></th>
                                    <th onClick={this.onSort('buildingName')} className="link_cursor">{label['TenantZones.Building.Text'] !== undefined ? label['TenantZones.Building.Text'] : "Building"}<span className={this.setArrow('buildingName')}></span></th>
                                    <th onClick={this.onSort('members')} className="link_cursor">{label['TenantZones.Members.Text'] !== undefined ? label['TenantZones.Members.Text'] : "Members"}<span className={this.setArrow('members')}></span></th>
                                    <th onClick={this.onSort('tenantNames')} className="link_cursor">{label['TenantZones.Tenants.Text'] !== undefined ? label['TenantZones.Tenants.Text'] : "Tenants"}<span className={this.setArrow('tenantNames')}></span></th>
                                </tr>

                                {Zones}
                            </tbody>
                        </Table>
                    </div>

                    <Modal isOpen={this.state.modal} toggle={this.toggle} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
                        <AddZoneForms />
                    </Modal>
                    <Modal isOpen={this.state.Editmodal} toggle={this.Edittoggle} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
                        <EditZoneForm parentToChildData={[this.state.zoneID,this.state.ZoneDetails]} jsonmembers={JSON.stringify(this.state.ZoneDetails)} />
                    </Modal>
                    <Modal isOpen={this.state.Deletemodal} Deletemodal={this.Deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")} >
                        <DeleteConfirmation parentToChildData={["Delete Zones", "Are you sure you want to delete Zone(s)"]} Delete={this.Delete} />
                    </Modal>
                </div>
            </div>
        );
    }

    searchUpdated(term) {
        this.setState({ searchTerm: term })
    }

}

const mapStateToProps = state => {
    return {
        getResponse: state.zonesRootReducer,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        ModalOpenCloseResponse: state.ModalOpenCloseRootReducer,
        UserCanEdit: state.authService.HasApplicationFullAcess
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetZonesList: () => dispatch(GetZonesList()),
        DeleteZone: (data) => dispatch(DeleteZone(data)),
        closeModalPopUp: (modaldata) => dispatch(closeModalPopUp(modaldata)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Zones);





